/* eslint no-param-reassign: 0 */
import fromUnixTime from "date-fns/fromUnixTime";
import { frontendURL } from "../../helper/URLHelper";

export const getLoadingStatus = (state) => state.fetchAPIloadingStatus;
export const setLoadingStatus = (state, status) => {
  state.fetchAPIloadingStatus = status;
};

export const setUser = (userData) => {
  localStorage.setItem("user", JSON.stringify(userData));
};
export const getHeaderExpiry = (response) => fromUnixTime(response.headers.expiry);

export const setAuthCredentials = (response) => {
  localStorage.setItem("auth_data", JSON.stringify(response.headers));

  setUser(response.data.data);
};

// Сессия, поднятая по access_token агента из URL (встраивание в iframe).
// Кладём токен в те же ключи localStorage, чтобы auth.isLoggedIn() и
// SET_CURRENT_USER работали без изменений.
export const setTokenAuthCredentials = (token, profile) => {
  localStorage.setItem("auth_data", JSON.stringify({ api_access_token: token }));

  setUser(profile);
};

export const clearSession = () => {
  localStorage.removeItem("auth_data");
  localStorage.removeItem("user");
};

export const clearCookiesOnLogout = () => {
  clearSession();

  window.location = frontendURL("login");
};
